import { externalFormSlice } from 'Pages/orders'
import { organizationSlice } from 'Pages/advertisement/store/slices/organizations.slice'
import { contractSlice } from 'Pages/advertisement/store/slices/contracts.slice'
import { creativeSlice } from 'Pages/advertisement/store/slices/creative.slice'
import { reportsSlice } from 'Pages/advertisement/store/slices/report.slice'
import { ChannelHandler, SocketMessageTypes, SocketMessage } from 'Modules/Socket'
import { Callback } from 'Src/types/utilTypes'

export class AdvertisementChannel implements ChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}

	public work(data: SocketMessage): void {
		const { message } = data
		const type = message?.type

		if (type === SocketMessageTypes.ORGANIZATION_STATUS && message?.payload?.organization_id) {
			const organization_id = message?.payload?.organization_id
			const external_id = message?.payload?.external_id
			const registered_at = message?.payload?.registered_at
			const status = message?.payload?.status
			this.dispatch(
				organizationSlice.actions.changeOrgFromSocket({
					organization_id,
					external_id,
					registered_at,
					status,
				})
			)
		}
		if (type === SocketMessageTypes.CONTRACT_STATUS && message?.payload?.contract_id) {
			const contract_id = message?.payload?.contract_id
			const external_id = message?.payload?.external_id
			const registered_at = message?.payload?.registered_at
			const status = message?.payload?.status
			this.dispatch(
				contractSlice.actions.changeContrFromSocket({
					contract_id,
					external_id,
					registered_at,
					status,
				})
			)
		}
		if (type === SocketMessageTypes.CREATIVE_STATUS && message?.payload?.creative_id) {
			const creative_id = message?.payload?.creative_id
			const external_id = message?.payload?.external_id
			const registered_at = message?.payload?.registered_at
			const status = message?.payload?.status
			const media_state = message?.payload?.media_state
			const marker = message?.payload?.marker
			this.dispatch(
				creativeSlice.actions.changeCreativeFromSocket({
					creative_id,
					external_id,
					registered_at,
					status,
					media_state,
					marker,
				})
			)
		}
		if (type === SocketMessageTypes.INVOICE_STATUS && message?.payload?.invoice_id) {
			const invoice_id = message?.payload?.invoice_id
			const external_id = message?.payload?.external_id
			const registered_at = message?.payload?.registered_at
			const status = message?.payload?.status
			this.dispatch(
				reportsSlice.actions.changeReportFromSocket({
					invoice_id,
					external_id,
					registered_at,
					status,
				})
			)
		}
		if (type === SocketMessageTypes.EXTERNAL_FORM_MARK_AD && message?.payload?.id) {
			const id = message?.payload?.id
			const advertisement = message?.payload?.advertisement
			const ad_marking_state = message?.payload?.ad_marking_state
			const landing_url_with_marker = message?.payload?.landing_url_with_marker
			this.dispatch(
				externalFormSlice.actions.adMarkingState({
					id,
					advertisement,
					ad_marking_state,
					landing_url_with_marker,
				})
			)
		}
	}
}
